import { AuthorizationReceivingController } from './authorizationReceiving.controller';
import template from './authorizationReceiving.html';

export const authorizationReceivingComponent = {
  name: 'authorizationReceivingComponent',
  restrict: 'E',
  template,
  controller: AuthorizationReceivingController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
